export default __webpack_public_path__ + "static/O0261-ecd889d45a6b10c514be082679377a24.png";